<ul class="top-list mt-4 mb-5">
  <li *ngFor="let item of activities; let i = index" class="d-flex">
    <div class="meta-col flex-grow-1">
      <div class="activity-type">{{ item?.type }}</div>
      <div class="activity-title">{{ item?.title }}</div>
    </div>

    <div class="meta-col meta-item"><i class="icon ftmi-location"></i> {{ item?.room?.name }}</div>
    <div class="meta-col meta-item">
      <i class="icon ftmi-schedule"></i>
      <span *ngIf="item?.topRecurringActivitiesCount">{{ item?.topRecurringActivitiesCount }}</span>
      <span *ngIf="item?.topAttendedActivitiesCount">{{ item?.topAttendedActivitiesCount }}</span>
      {{ 'DAYS' | translate | lowercase }}
    </div>

    <button class="round-btn ml-auto" (click)="onOpenActivityInfo(item)" [appTooltip]="'INFO' | translate"><i class="ftmi-info"></i></button>
  </li>
</ul>
<div class="alert justify-content-center" *ngIf="!hasActivities">
  {{ 'NO_TOP_ACTIVITIES' | translate }}
</div>
